import React, { useEffect, useRef, useState } from "react";
import { FiShoppingCart } from "react-icons/fi";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { Link } from "react-router-dom";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { MdFilterList, MdArrowDropDown } from "react-icons/md";
import { CustomeStyle } from "../Css/CustomeStyle";
import Footer from "../Fotter";
import Header from "../pages/header";
import { useDispatch, useSelector } from "react-redux";
import { clearAllCategory, GetCategory } from "../redux/slices/GetCategorySlice";
import { GetBrands } from "../redux/slices/GetBrandSlice";
import { fetchProducts } from "../redux/slices/AllProductSlice";
import { AddToCart } from "../redux/slices/AddTocartSlice";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import ReactPaginate from "react-paginate";
import { AddWishlist } from "../redux/slices/AddWishlistSlice";
import { GetCategoryData } from "../redux/slices/GetCategoryDataSlice";
import { GetSubCategory } from "../redux/slices/GetSubCategorySlice";
import { clearFilterProductData } from "../redux/slices/FilterProductSlice";
import { clearPriceFilterData } from "../redux/slices/PriceFilterSlice";

function AllProductData() {
  const location = useLocation();
  const sidebarRef = useRef(null);
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [likedProducts, setLikedProducts] = useState(new Set());
  const [isSidebarVisible1, setIsSidebarVisible1] = useState(false);
  const dispatch = useDispatch();
  const { AllCategory } = useSelector((state) => state?.category);
  const [isVisible, setIsVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [ordersPerPage] = useState(50);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);
  const { CategoryData, totalPagesCategory } = useSelector((state) => state.categoryData);
  const [activeSubCategory, setActiveSubCategory] = useState("");
  const { AllSubCategory, totalPages } = useSelector((state) => state.subCategory);
  const { AllData } = useSelector((state) => state?.product);
  const [showAll, setShowAll] = useState(false);

  const visibleCategories = showAll ? AllCategory : AllCategory.slice(0, 6);

  useEffect(() => {
    if (location.state?.page !== undefined) {
      setCurrentPage(location.state.page);
    }
  }, [location.state]);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      if (activeCategory) {
        try {
          // await dispatch(GetCategoryData(activeCategory)).unwrap();
          dispatch(
            GetCategoryData({
              name: activeCategory,
              page: currentPage + 1,
              limit: 50,
            })
          );
          // await dispatch(GetSubCategory(activeCategory)).unwrap();
          dispatch(
            GetSubCategory({
              name: activeCategory,
              page: currentPage + 1,
              limit: 50,
            })
          )
        } catch (error) {
          console.error("Error fetching category/subcategory:", error);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [dispatch, activeCategory, currentPage]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        await dispatch(GetCategory());
        await dispatch(fetchProducts()).unwrap();
      } catch (error) {
        console.log("Error", Error)
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch]);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const toggleLike = (productId) => {
    dispatch(AddWishlist(productId));
    setLikedProducts((prevLikedProducts) => {
      const updatedLikes = new Set(prevLikedProducts);
      if (updatedLikes.has(productId)) {
        updatedLikes.delete(productId);
      } else {
        updatedLikes.add(productId);
      }
      return updatedLikes;
    });
  };

  const handleAddToCart = (item) => {
    const cartData = {
      productId: item?._id,
      quantity: 1,
    };
    dispatch(AddToCart(cartData)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        toast.success("Product added to cart!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
          },
        });
      } else {
        console.log("Responce Error");
      }
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsSidebarVisible1(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsSidebarVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const generateSlug = (text) => {
    if (!text) {
      return "";
    }
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  // const getFilteredData = () => {
  //   if (CategoryData?.products) {
  //     return CategoryData.products?.length > 0
  //       ? CategoryData.products
  //       : [];
  //   }
  //   if (AllSubCategory?.products) {
  //     return AllSubCategory.products?.length > 0
  //       ? AllSubCategory.products
  //       : [];
  //   }
  //   // AllSubCategory
  //   // if (AllSubCategory?.products?.length > 0)
  //   //   return AllSubCategory.products;
  //   // return AllSubCategory?.products?.length > 0 ? AllSubCategory.products : [];
  //   // if (FilterProductData?.products?.length > 0)
  //   //   return FilterProductData.products;
  //   return AllData?.products?.length > 0 ? AllData.products : [];
  // };

  const getFilteredData = () => {
    if (AllSubCategory?.products?.length > 0) {
      return AllSubCategory.products;
    }
    if (CategoryData?.products?.length > 0) {
      return CategoryData.products;
    }
    return AllData?.products?.length > 0 ? AllData.products?.slice(0, 50) : [];
  };


  const filteredData = getFilteredData();
  const productData = filteredData;

  const subCategoryData = AllCategory?.find(
    (category) => category.name === activeCategory
  );

  const handleCategoryClick = (category) => {
    setShowAll(false)
    setActiveSubCategory("")
    setActiveCategory((prev) =>
      prev === category?.name ? null : category?.name
    );
  };

  const _handleGo = async (name) => {
    setLoading(true);
    // const page = 0;
    // setCurrentPage(page)
    try {
      // await dispatch(GetSubCategory(name)).unwrap();
      dispatch(
        GetSubCategory({
          name: name,
          page: currentPage + 1,
          limit: 50,
        })
      )
      setActiveSubCategory(name);
    } catch (error) {
      console.error("Error fetching subcategory:", error);
    } finally {
      setLoading(false);
    }
  };

  const scrollRef = useRef();
  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -200, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
  };

  //   const _handlePaginationCall = (name, selected) => {
  // setLoading(true);  
  //   dispatch(clearPriceFilterData());
  //     dispatch(clearFilterProductData());

  //     dispatch(
  //       GetSubCategory({
  //         name: name,
  //         page: selected + 1,
  //         limit: 50,
  //       })
  //     ).unwrap()
  //     setActiveSubCategory(name);
  //   };

  const _handlePaginationCall = async (name, selected) => {
    try {
      setLoading(true);
      dispatch(clearPriceFilterData());
      dispatch(clearFilterProductData());

      await dispatch(
        GetSubCategory({
          name: name,
          page: selected + 1,
          limit: 50,
        })
      ).unwrap();

      setActiveSubCategory(name);
    } catch (error) {
      console.error("Error in pagination call:", error);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="min-h-screen bg-gray-50 ">
      {/* <Header /> */}
      <h1 className="text-black sm:py-5 py-2 font-bold p-2 text-center text-lg">All Categories</h1>
      <div className="flex gap-3 sm:gap-3 overflow-x-auto w-full self-center justify-center items-center">
        <div className="sm:block hidden w-[90%] self-center items-center justify-center bg-gray-100 to-white  bg-gray-10 p-5">
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-4 ">
            {AllCategory?.map((category, index) => (
              <div
                key={index}
                className="flex flex-col items-center cursor-pointer"
                onClick={() => handleCategoryClick(category)}
              >
                <img
                  loading="lazy"
                  src={category.image}
                  alt={category.name}
                  className="w-14 h-14 rounded-full object-cover mb-2"
                />
                <p className="text-black font-medium text-sm text-center w-[80%] line-clamp-2">
                  {category.name}
                </p>
              </div>
            ))}
          </div>

        </div>
        <div className="bg-gray-100 to-white">
          <div className=" self-center items-center justify-center bg-gray-10 p-5 sm:hidden block">
            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-4 ">
              {visibleCategories?.map((category, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center cursor-pointer"
                  onClick={() => handleCategoryClick(category)}
                >
                  <img
                    loading="lazy"
                    src={category.image}
                    alt={category.name}
                    className="w-14 h-14 rounded-full object-cover mb-2"
                  />
                  <p className="text-black font-medium text-sm text-center w-[80%] line-clamp-2">
                    {category.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
          {AllCategory?.length > 6 && (
            <div className="w-full text-center block sm:hidden p-2">
              <button
                className="text-black font-semibold bg-white px-2 py-1 rounded-sm"
                onClick={() => setShowAll(!showAll)}
              >
                {showAll ? "View Less" : "View All Categories"}
              </button>
            </div>
          )}
        </div>

      </div>

      <div className="w-[90%] mx-auto flex flex-col md:flex-row gap-8 justify-center mb-[3%]">
        <div className="w-full sm:w-[60%] md:w-[100%] mt-0 md:mt-1">
          {loading ? (
            <div className="flex justify-center items-center w-full py-10">
              <div className="text-center font-semibold text-lg py-5">Loading...</div>
            </div>
          ) : (
            <div className="">
              {activeCategory && <h1 className="text-black m-2 font-bold p-2 text-center text-lg">More in {activeCategory}</h1>}
              {subCategoryData?.subcategories?.length > 0 &&
                <div className="relative w-full sm:w-[95%] md:w-full mb-3">
                  <div className="bg-gray-100 border border-gray-200 sm:px-4 sm:py-2 px-3 py-1 mx-auto rounded-md ">
                    <MdChevronLeft
                      className="absolute left-0 top-[45%] z-10 text-gray-600 bg-white rounded-full shadow-md cursor-pointer "
                      size={35}
                      onClick={scrollLeft}
                    />
                    <div
                      ref={scrollRef}
                      className="overflow-x-auto no-scrollbar scroll-smooth "
                    >
                      <style>{` div::-webkit-scrollbar {  display: none;   } `}
                      </style>
                      <div className="py-1 px-2 flex sm:gap-12 gap-4 w-max ">
                        {subCategoryData?.subcategories.map((subcategory, subIndex) => (
                          <div
                            key={subIndex}
                            onClick={() => _handleGo(subcategory.name)}
                            className="text-center flex-shrink-0 items-center"
                          >
                            <img
                              loading="lazy"
                              src={subcategory.image}
                              alt={subcategory.name}
                              className="w-16 h-16 mx-auto rounded-full object-cover hover:scale-105 transition-transform mt-1"
                            />
                            <p className="text-sm font-medium text-gray-700 mb-3 w-[80%] line-clamp-2 text-center">
                              {subcategory.name}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                    <MdChevronRight
                      className="absolute right-0 top-[45%] z-10 text-gray-600 bg-white rounded-full shadow-md cursor-pointer "
                      size={35}
                      onClick={scrollRight}
                    />
                  </div>
                </div>
              }
              {activeSubCategory && <h1 className="text-black m-2 font-bold p-2 text-center text-lg">{activeSubCategory} Collection</h1>}
              <div className=" grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-1 lg:gap-3 mt-3">
                {productData?.length > 0 ? (
                  productData?.map((item) => (
                    <div
                      key={item?._id}
                      className="bg-white shadow rounded-md overflow-hidden relative border border-gray-200 
                    sm:px-4 sm:py-2 px-3 py-2 hover:scale-105 hover:-translate-y-1"
                    >
                      <img
                        loading="lazy"
                        src={item?.images?.productimage1}
                        alt={item?.images?.itemimage1}
                        className="w-full h-28 object-contain rounded-x"
                      />
                      <button
                        className="like-btn absolute top-2 left-2"
                        onClick={() => toggleLike(item._id)}
                      >
                        {likedProducts.has(item._id) ? (
                          <FaHeart
                            size="24px"
                            className="text-red-500 sm:text-lg text-xs"
                          />
                        ) : (
                          <FaRegHeart
                            size="24px"
                            className="text-gray-400 sm:text-lg md:text-xs"
                          />
                        )}
                      </button>
                      {item?.outOfStock ? <span className=" absolute bg-gray-200 top-2 right-2  p-1  text-red-500 text-bold text-gray-400 sm:ml-20 ml-0">
                        Out of stock
                      </span> :
                        <button
                          onClick={() => handleAddToCart(item)}
                          className="like-btn absolute top-2 right-2 px-2 py-2 bg-gray-100 text-white rounded-lg hover:bg-green-50"
                        >
                          <FiShoppingCart className="text-gray-700 sm:text-base md:text-xl lg:text-2xl" />
                        </button>
                      }
                      <Link
                        to={`/shop/${item?.category ? generateSlug(item?.category) : "-"
                          }/${item?.subcategory ? generateSlug(item?.subcategory) : "-"
                          }/${generateSlug(item?.title)}`}
                        state={{
                          item,
                          page: currentPage,
                        }}
                        className="block w-[100%] hover:scale-105 hover:-translate-y-1"
                      >
                        <div className="end-2 lg:mt-3">
                          <h2
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              textAlign: "center",
                            }}
                            className={CustomeStyle.OnetextBlack}
                          >
                            {item?.title}
                          </h2>
                          <div>
                            {/* <span className={CustomeStyle.description}>
                              {item.description}
                            </span> */}
                          </div>
                          <div className="flex items-center justify-center gap-2">
                            <span className={CustomeStyle.text}>
                              ₹{item?.salePrice}
                            </span>
                            <span className="line-through text-gray-500 text-sm">
                              ₹{item?.regularPrice}
                            </span>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))
                ) : (
                  <div className="flex items-center justify-center w-full text-black font-semibold text-lg mt-5">
                    No Products Found
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <button
        onClick={scrollToTop}
        className={`fixed bottom-5 right-5 border bg-gray-200 text-black font-semibold px-4 py-2 rounded-full shadow-lg transition-all duration-300 ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-0"
          }`}
      >
        ⬆ Top
      </button>
      {/* <div className="w-full flex justify-center mt-6 mb-5">
        <div className="w-full max-w-[90%] sm:max-w-[70%] md:max-w-[60%] lg:max-w-[50%] overflow-auto">
          <ReactPaginate
            previousLabel={
              <span className="px-1 py-1 text-xs sm:text-sm font-medium whitespace-nowrap">
                Prev
              </span>
            }
            nextLabel={
              <span className="px-1 py-1 text-xs sm:text-sm font-medium whitespace-nowrap">
                Next
              </span>
            }
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={1}
            pageRangeDisplayed={window.innerWidth > 768 ? 5 : 3}
            onPageChange={handlePageClick}
            containerClassName="flex items-center justify-center gap-2 px-2 py-2 overflow-auto no-scrollbar"
            pageClassName="rounded-md border border-black hover:bg-blue-500 hover:text-white transition duration-300"
            pageLinkClassName="w-full h-full px-2 py-1 text-xs sm:text-sm flex items-center justify-center cursor-pointer"
            activeClassName="bg-blue-500 text-white border-blue-600"
            previousClassName="px-2 py-1 text-xs sm:text-sm border border-gray-200 rounded-md bg-gray-100 hover:bg-blue-500 hover:text-white transition duration-300 cursor-pointer"
            nextClassName="px-2 py-1 text-xs sm:text-sm border border-gray-200 rounded-md bg-gray-100 hover:bg-blue-500 hover:text-white transition duration-300 cursor-pointer"
            breakClassName="px-2 py-1 text-gray-500"
            disabledClassName="opacity-50 cursor-not-allowed"
            forcePage={currentPage}
          />
        </div>
      </div> */}
      <div className="w-full flex justify-center mt-6 mb-5">
        <div className="w-full max-w-[90%] sm:max-w-[70%] md:max-w-[60%] lg:max-w-[50%] overflow-auto">
          <ReactPaginate
            previousLabel={
              <span className="px-1 py-1 text-xs sm:text-sm font-medium whitespace-nowrap">
                Prev
              </span>
            }
            nextLabel={
              <span className="px-1 py-1 text-xs sm:text-sm font-medium whitespace-nowrap">
                Next
              </span>
            }
            breakLabel={"..."}
            pageCount={totalPages ? totalPages : totalPagesCategory}
            marginPagesDisplayed={1}
            pageRangeDisplayed={window.innerWidth > 768 ? 5 : 3}
            // onPageChange={handlePageClick}
            onPageChange={({ selected }) => {
              setCurrentPage(selected);
              if (activeSubCategory) {
                _handlePaginationCall(activeSubCategory, selected)
              }
              if (activeCategory && !activeSubCategory) {
                console.log("Hellooo")
              }
            }}
            containerClassName="flex items-center justify-center gap-2 px-2 py-2 overflow-auto no-scrollbar"
            pageClassName="rounded-md border border-black hover:bg-blue-500 hover:text-white transition duration-300"
            pageLinkClassName="w-full h-full px-2 py-1 text-xs sm:text-sm flex items-center justify-center cursor-pointer"
            activeClassName="bg-blue-500 text-white border-blue-600"
            previousClassName="px-2 py-1 text-xs sm:text-sm border border-gray-200 rounded-md bg-gray-100 hover:bg-blue-500 hover:text-white transition duration-300 cursor-pointer"
            nextClassName="px-2 py-1 text-xs sm:text-sm border border-gray-200 rounded-md bg-gray-100 hover:bg-blue-500 hover:text-white transition duration-300 cursor-pointer"
            breakClassName="px-2 py-1 text-gray-500"
            disabledClassName="opacity-50 cursor-not-allowed"
            forcePage={currentPage}
          />
        </div>
      </div>
      < Footer />
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg p-6 w-[300px] text-center shadow-lg">
            <h2 className="text-xl font-bold mb-2">Coming Soon</h2>
            <p className="text-gray-600 mb-4">Products for this category will be available soon</p>
            <button
              onClick={() => setShowModal(false)}
              className="mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Close
            </button>
          </div>
        </div>
      )}

    </div>
  );
}

export default AllProductData;
